<template>
  <div class="playback-speed-button">
    <div class="speed-slider-wrapper">
      <tooltip tooltip-text="再生速度">
        <div class="speed-icon-wrapper" @click="onClick">
          <speed-icon></speed-icon>
        </div>
      </tooltip>

      <span class="speed-slider" v-show="isShow" @mouseleave="onMouseLeave">
        <vue-slider
          ref="rgPlaybackSlider"
          v-model="value"
          direction="btt"
          :height="120"
          :min="min"
          :max="max"
          :interval="1"
          :tooltip="tooltip"
          :process-style="processStyle"
          @change="onChange"
        >
        </vue-slider>
      </span>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import SpeedIcon from "./SpeedIcon";
import Tooltip from "../Tooltip.vue";

export default {
  name: "PlaybackSpeedButton",
  components: { VueSlider, SpeedIcon, Tooltip },
  data() {
    return {
      max: 240,
      min: 1,
      tooltip: "none",
      value: 60,
      isShow: false,
      processStyle: {
        border: "2px solid #4D9EF2",
      },
    };
  },
  methods: {
    onChange() {
      this.$emit("updatePlaybackSpeed", this.value / 60);
    },
    onClick() {
      this.isShow = !this.isShow;
    },
    onMouseLeave() {
      this.isShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.playback-speed-button {
  line-height: 1;
  width: 44px;
  height: 44px;
  .speed-slider-wrapper {
    position: relative;
    cursor: pointer;
    font-size: 0.9em;
    display: inline-block;
  }

  .speed-icon-wrapper {
    line-height: 1;
    width: 44px;
    height: 44px;
    ::v-deep svg path {
      fill: $aisea-blue;
    }
    &:hover {
      ::v-deep svg path {
        fill: #328dc0;
      }
    }
    &:active {
      ::v-deep svg path {
        fill: #2075a6;
      }
    }
  }

  .speed-slider {
    position: absolute;
    padding: 10px;
    font-size: 12px;
    line-height: 1.6em;
    color: $aisea-white;
    border-radius: 5px;
    background: #000;
    width: 40px;
    display: inline-block;
    visibility: visible;
    top: -150px;
    left: 1px;
    opacity: 1;

    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
